import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

interface SavedSearchState {
  selectedTreeItemId: string | null;
}

const initialState: SavedSearchState = {
  selectedTreeItemId: null,
};

const savedSearchSlice = createSlice({
  name: 'savedSearch',
  initialState,
  reducers: {
    setSelectedTreeItemId: (state, action: PayloadAction<string | null>) => {
      state.selectedTreeItemId = action.payload;
    },
  },
});

export const { setSelectedTreeItemId } = savedSearchSlice.actions;
export default savedSearchSlice.reducer;
